import type { MerchantBillingStatusDto } from "@price-rescue/api-contracts";
import { MERCHANT_OPERATIONS } from "@price-rescue/api-contracts";

import type { MerchantApiClient } from "../../types.js";

interface DataEnvelope<T> {
  data: T;
  meta: { requestId: string };
}

export interface BillingApi {
  getStatus(): Promise<MerchantBillingStatusDto>;
  refreshStatus(): Promise<MerchantBillingStatusDto>;
}

export function createBillingApi(client: MerchantApiClient): BillingApi {
  return {
    async getStatus() {
      return (
        await client.get<DataEnvelope<MerchantBillingStatusDto>>(
          MERCHANT_OPERATIONS.getMerchantBilling.path,
        )
      ).data;
    },
    async refreshStatus() {
      return (
        await client.post<DataEnvelope<MerchantBillingStatusDto>>(
          MERCHANT_OPERATIONS.refreshMerchantBilling.path,
          {},
          { idempotencyKey: crypto.randomUUID() },
        )
      ).data;
    },
  };
}
